import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config'; 



@Injectable()
export class SelfReportService {
    constructor(
        private httpService: HttpService) { }

    now = new Date();
    tomorrow = new Date(this.now.getDate() + 1);

    //获取主账户报表信息
    //TQQ 2016-12-28
    getSelfReport(obj) {
        let param ="startDate=" + obj.startDate + "&endDate=" + obj.endDate + "&pageSize=" + obj.pageSize + "&pageIndex=" + obj.pageIndex + "&userName=" + obj.userName;
        let url = AppConfig.GetProdUrl() + "/Report/User" ;
        return this.httpService.get(url+"?"+param);
    }


}





// WEBPACK FOOTER //
// ./src/services/selfreport.service.ts